import { Link } from "react-router-dom";
import { ArrowRight, Tag } from "lucide-react";

interface CategoryCardProps {
  title: string;
  description: string;
  image: string;
  href: string;
  itemCount: number;
}

const CategoryCard = ({ title, description, image, href, itemCount }: CategoryCardProps) => {
  return (
    <Link
      to={href}
      className="group relative overflow-hidden rounded-2xl bg-card shadow-card hover:shadow-elevated transition-all duration-500"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
          decoding="async"
          width={400}
          height={300}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-earth/90 via-earth/40 to-transparent" />
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-golden/90 text-earth text-xs font-semibold rounded-full mb-3">
          <Tag className="h-3 w-3" />
          {itemCount} Items
        </span>
        <h3 className="font-display text-2xl font-bold text-cream mb-2 group-hover:text-golden-light transition-colors">
          {title}
        </h3>
        <p className="text-cream/80 text-sm mb-4 line-clamp-2">{description}</p>
        <span className="inline-flex items-center gap-2 text-golden-light font-medium text-sm group-hover:gap-3 transition-all">
          Explore
          <ArrowRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
};

export default CategoryCard;
